import { ActionTypes } from '../constants/actionTypes';

const initialState = {
    selectedAuditType : "site",
}

export const auditLogReducer = (state= initialState, {type, payload}) => {
  switch(type) {
    case ActionTypes.SET_AUDIT_TYPE_SELECTION:
        return{...state, selectedAuditType: payload};
    default:
    return state;
  }
}